import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';
import useDedicatedFileUpload from './useDedicatedFileUpload';
import { prepFileMetaDataForDedicatedUpload } from '../utils/helper';
import { buildCaseInfoPaths } from '../utils/caseFieldPaths';
import LoggedInUserService from '../services/AuthService';
import { RECORD_DATA_TYPE } from '@demandproai/shared';
import useCaseRecordDelete from './useCaseRecordDelete';

const useCaseInfo = () => {
  const { caseId } = useParams();
  const { formik, getFieldProps, getMultiSelectFieldProps, processCount } = useAddCaseFormContext();
  const [showIntegratorList, setShowIntegratorList] = useState(false);
  const { handleFileRemove } = useCaseRecordDelete();

  const { isDelayedPayment } = useSelector((state) => state.users || {});

  const { isLoading, dedicatedFileUpload, startFileUpload, completeFileUpload } = useDedicatedFileUpload(caseId, RECORD_DATA_TYPE.LETTER_OF_PROTECTION);
  const caseInfoPaths = buildCaseInfoPaths();

  const caseInfoFileUpload = async (fileKey, files) => {
    console.log('🔵 fileUploadFunc called:', { fileKey, files });
    const fileArray = files?.file;
    if (!fileArray || fileArray.length === 0) {
      console.log('❌ No files provided');
      return;
    }
    const lastFile = fileArray[fileArray.length - 1];

    const fileObj = { file: lastFile };

    console.log('📝 Setting formik value for:', `caseInfo.${fileKey}`, fileObj);
    formik.setFieldValue(`caseInfo.${fileKey}`, fileObj);

    const prepFiles = prepFileMetaDataForDedicatedUpload([fileObj]);
    const fileCount = prepFiles.length;

    console.log('📤 Starting file upload, count:', fileCount);
    startFileUpload(fileCount);

    const updateCasePayload = {
      fieldKey: caseInfoPaths.field(fileKey),
      action: 'update'
    };
    console.log('🚀 Calling dedicatedFileUpload with payload:', updateCasePayload);

    const dedicatedFiles = await dedicatedFileUpload(prepFiles, updateCasePayload);
    console.log('✅ Upload complete, dedicatedFiles:', dedicatedFiles);

    const uploadedFile = dedicatedFiles[0];
    formik.setFieldValue(`caseInfo.${fileKey}`, uploadedFile);

    completeFileUpload(fileCount);
    console.log('🎉 File upload finished');
  };

  const caseInfoRemoveFile = async (key,fileToRemove) => {
    handleFileRemove({
      formik,
      fileToRemove,
      filePath: `caseInfo.${key}`,
      removeData: { [caseInfoPaths.field(key)]: null }
    })
  };

  const isShowForceReset = useMemo(()=>{
    return processCount > 0 && LoggedInUserService.GetLoggedInUserData().isAdmin
  }, [processCount]);

  return {
    formik,
    getFieldProps,
    getMultiSelectFieldProps,
    showIntegratorList,
    setShowIntegratorList,
    isDelayedPayment,
    isLoading,
    isShowForceReset,
    caseInfoFileUpload,
    caseInfoRemoveFile,
  };
};

export default useCaseInfo;
